import React, { useState } from "react"

import styles from "./NoteInput.module.css"

import Button from "~/common/buttons/Button"
import * as icons from "~/common/react-icons"

const NoteInput = ({
  onSubmit,
}: {
  onSubmit: (note: string) => Promise<void>
}) => {
  const [note, setNote] = useState("")

  const createNote = async () => {
    const trimmedNote = note.trim()

    if (!trimmedNote) {
      return
    }

    await onSubmit(trimmedNote)
    setNote("")
  }

  const handleShortcut = async (
    e: React.KeyboardEvent<HTMLTextAreaElement>,
  ) => {
    if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) {
      await createNote()
    }
  }

  return (
    <div className={styles.commentBox}>
      <textarea
        className={styles.commentTextArea}
        placeholder="Add notes, important links, etc."
        data-test="comment-input"
        value={note}
        onChange={(e) => setNote(e.target.value)}
        onSubmit={createNote}
        onKeyDown={handleShortcut}
      />
      <Button
        className={styles.sendBtn}
        onClick={createNote}
        outlined={false}
        icon={<icons.Send />}
      />
    </div>
  )
}

export default NoteInput
